// extracted by mini-css-extract-plugin
module.exports = {"fullName":"UserAvatarAndName_fullName__13wLl"};